<template>
  <div>
    <div class="kongtiaojifang" ref="kongtiao" @mousedown="mouseDownHandleelse($event)" @mouseup="mouseUpHandleelse($event)" v-if="prinpageif">
      <table class="ui_dialog">
        <tbody>
          <tr>
            <td class="ui_l">
              <div class="ui_title_bar">
                <div class="ui_title" style="cursor: move;">打印送货单</div>
                <div class="ui_title_buttons">
                  <a class="ui_min" title="最小化" style="display: inline-block" @click="uimin('1')" v-if="PrintPagemin">
                    <b class="ui_min_b"></b>
                  </a>
                  <a class="ui_max" href="javascript:void(0);" title="最大化" v-if="!PrintPagemin" @click="uimin('2')">
                    <b class="ui_max_b"></b>
                  </a>
                  <a class="ui_close" href="javascript:void(0);" title="关闭(esc键)" style="display: inline-block" @click="printclsoe()">×</a>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="ui_main" style="width: 1100px; ">
              <iframe name="PrintPage" id="PrintPage" v-if="PrintPagemin" frameborder="0" style="width: 100%; height: 500px; border: 0px none" :src="prinpagesrc"></iframe>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    prinpageif: { Type: Boolean },
    prinpagesrc: { Type: String },
  },
  data() {
    return {
      PrintPagemin: true,

      moveDataelse: {
        x: null,
        y: null,
      },
    };
  },
  created() {
    console.log(this.prinpageif, this.prinpagesrc);
  },
  methods: {
    printclsoe() {
      this.$emit("printclose", false);
    },
    // 拖拽
    mouseDownHandleelse(event) {
      this.moveDataelse.x = event.pageX - this.$refs.kongtiao.offsetLeft;
      this.moveDataelse.y = event.pageY - this.$refs.kongtiao.offsetTop;
      event.currentTarget.style.cursor = "move";
      window.onmousemove = this.mouseMoveHandleelse;
    },
    mouseMoveHandleelse(event) {
      let moveLeft = event.pageX - this.moveDataelse.x + "px";
      let moveTop = event.pageY - this.moveDataelse.y + "px";
      this.$refs.kongtiao.style.left = moveLeft;
      this.$refs.kongtiao.style.top = moveTop;
    },
    mouseUpHandleelse(event) {
      window.onmousemove = null;
      event.currentTarget.style.cursor = "move";
    },
    uimin(val) {
      if (val == "1") {
        this.PrintPagemin = false;
      } else {
        this.PrintPagemin = true;
      }
    },
  },
};
</script>

<style scoped>
@import url(../../../../assets/css/default.css);

.kongtiaojifang {
  height: 500px;
  width: 100%;
  position: absolute;
  top: 150px;
  left: 100px;
  cursor: pointer;
}
.ui_dialog {
  border: 5px solid #4a5b79;
}
</style>
